import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { verifyJob } from '../api';
import logoBt from '../logo-bt.png';
import './verify.css';

function VerifyPage() {
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('requestId');

  const [loading, setLoading] = useState(true);
  const [jobData, setJobData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!requestId) {
      setError('Invalid verification link');
      setLoading(false);
      return;
    }

    const verify = async () => {
      try {
        setLoading(true);
        const data = await verifyJob(requestId);
        setJobData(data);
        setError(null);
      } catch (err) {
        // console.error('[VerifyPage] Verification failed:', err);
        setError('Unable to verify your request. The link may be invalid or expired.');
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [requestId]);

  return (
    <div className="verify-page">
      <nav className="verify-nav">
        <Link to="/" className="verify-nav-logo-link">
          <img src={logoBt} alt="Blacktop logo" className="verify-nav-logo" />
        </Link>
      </nav>

      <main className="verify-main">
        {loading && (
          <div className="verify-card">
            <div className="verify-spinner" />
            <h1 className="verify-title">Verifying your request...</h1>
            <p className="verify-text">Please wait a moment</p>
          </div>
        )}

        {!loading && error && (
          <div className="verify-card verify-card--error">
            <div className="verify-icon verify-icon--error">✕</div>
            <h1 className="verify-title">Verification Failed</h1>
            <p className="verify-text">{error}</p>
            <div className="verify-divider" />
            <p className="verify-footer">
              Need help?{' '}
              {/* <a href="mailto:support@blacktop.com" className="verify-link">
                Contact support
              </a> */}
              Call us
              {' '}or{' '}
              <Link to="/" className="verify-link">
                return home
              </Link>
            </p>
          </div>
        )}

        {!loading && !error && jobData && (
          <div className="verify-card verify-card--success">
            <div className="verify-icon verify-icon--success">✓</div>
            <h1 className="verify-title">Request Verified!</h1>
            <p className="verify-text">
              Your estimate request has been confirmed
            </p>

            <div className="verify-details">
              {jobData.job?.location?.name && (
                <div className="verify-detail-row">
                  <span className="verify-detail-label">Address:</span>
                  <span className="verify-detail-value">{jobData.job.location.name}</span>
                </div>
              )}
            </div>

            <div className="verify-divider" />

            <div className="verify-next-steps">
              <h3 className="verify-next-title">What's Next?</h3>
              <ul className="verify-next-list">
                <li>Our team will review your request soon</li>
                <li>You'll receive a detailed quote via email</li>
                <li>Schedule your paving project at your convenience</li>
              </ul>
            </div>

            <div className="verify-footer">
              <Link to="/" className="verify-btn">
                Return Home
              </Link>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

export default VerifyPage;
